"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SuperContext = void 0;
var react_1 = __importStar(require("react"));
/**
 * The SuperContext is a provider component for all contexts created with createSuperContext.
 */
exports.SuperContext = function (_a) {
    var contexts = _a.contexts, defaultOptions = _a.defaultOptions, children = _a.children;
    return contexts.length === 0 ? (react_1.default.createElement(react_1.default.Fragment, null, children)) : (react_1.default.createElement(SubContext, { contexts: contexts, defaultOptions: defaultOptions, index: 0 }, children));
};
// library's default options, can be overridden
var fallbackOptions = {
    interceptors: [],
    displayName: "SuperContext",
};
var SubContext = function (_a) {
    var contexts = _a.contexts, defaultOptions = _a.defaultOptions, index = _a.index, children = _a.children;
    var superContext = contexts[index];
    if (!superContext)
        throw new Error("SuperContext was null/undefined");
    var _b = typeof superContext === "function" ? superContext() : superContext, context = _b.context, factory = _b.factory, props = _b.props, options = _b.options;
    var _c = react_1.useMemo(function () { return (__assign(__assign(__assign({}, fallbackOptions), defaultOptions), options)); }, [defaultOptions, options]), displayName = _c.displayName, interceptors = _c.interceptors;
    var value = factory(props);
    if (interceptors) {
        for (var _i = 0, interceptors_1 = interceptors; _i < interceptors_1.length; _i++) {
            var interceptor = interceptors_1[_i];
            value = interceptor(value);
        }
        if (interceptors.length > 0) {
            console.warn("react-super-context: Interceptors have been deprecated, see https://github.com/goransh/react-super-context/wiki/Interceptors-deprecated");
        }
    }
    react_1.useEffect(function () {
        context.displayName = displayName;
    }, [displayName]);
    var nextIndex = index + 1;
    return (react_1.default.createElement(context.Provider, { value: value }, nextIndex < contexts.length ? (react_1.default.createElement(SubContext, { contexts: contexts, index: nextIndex }, children)) : (children)));
};
